import { Component, OnInit } from '@angular/core';
import { ITdDynamicElementConfig, TdDynamicElement, TdDynamicType } from '@covalent/dynamic-forms';
import { TdFileService, IUploadOptions } from '@covalent/core';
import { LocationService } from 'services/location.service';
import { TdLoadingService } from '@covalent/core';
import { TdDialogService } from '@covalent/core';

import { Company } from '../../company';
import { Subscription } from 'rxjs/Subscription';
import { ActivatedRoute, ParamMap, Router } from '@angular/router';
import { Location } from '@angular/common';
import 'rxjs/add/operator/switchMap';
import 'rxjs/add/operator/do';
import { Observable } from 'rxjs/Observable';
import { Customer } from '../../customer';
import { CustomerService } from '../customer.service';
import { AuthenticationService } from '../../../../shared/services/authentication.service';
import { MdDialogRef, MdDialog } from '@angular/material';
import { Branch } from '../../branch';
import { BranchService } from '../../branches/branch.service';

@Component({
  selector: 'app-customer',
  templateUrl: './customer.component.html',
  styleUrls: ['./customer.component.scss'],
  providers: [CustomerService]
})
export class CustomerComponent implements OnInit {
  data: Customer;
  currentCustomer: Customer;

  originalCustomer: Customer;
  originalCreditMargin: string;
  originalCreditDate: string;

  subscription: Subscription = new Subscription();
  allCity: any[];
  title: string;
  isEditMode: boolean;

  valid_salesmen: string[] = [];
  allBranches: Branch[];

  //interim values
  credit_margin: string;
  credit_date: string;
  city: any;
  shipping_city: any;

  _useShipping: boolean = true;

  constructor(private _dialogService: TdDialogService,
    private _loadingService: TdLoadingService,
    private _customerService: CustomerService,
    private _locationService: LocationService,
    private _branchService: BranchService,
    public _authService: AuthenticationService,
    private _dialog: MdDialog,
    private route: ActivatedRoute,
    private router: Router,
    private location: Location) { }

  ngOnInit(): void {
    this._loadingService.register('loading');

    this._branchService.getBranches().subscribe(
      (b: Branch[]) => {
        this.allBranches = b;
      }
    );

    this.route.paramMap.switchMap((params: ParamMap) => this.mode(params.get('id'))).subscribe(
      (currentCustomer: Customer) => {
        this.currentCustomer = currentCustomer;
        // Use one or another address
        if (this.currentCustomer.shipping_address != null && this.currentCustomer.shipping_address != '') {
          this._useShipping = false;
        } else {
          this._useShipping = true;
        }

        console.log(this._useShipping, this.currentCustomer.shipping_address);
        // Load up the reference data
        this.originalCustomer = Object.assign({}, this.currentCustomer);

        // Load the latest and greatest margin
        if (this.currentCustomer != null && this.currentCustomer.credit_margin != null && Array.isArray(this.currentCustomer.credit_margin) && this.currentCustomer.credit_margin.length > 0) {
          this.credit_margin = this.currentCustomer.credit_margin[0].margin;
          this.credit_date = this.currentCustomer.credit_margin[0].date.substr(0, 10);

          this.originalCreditMargin = this.credit_margin;
          this.originalCreditDate = this.credit_date;
        } else {
          // Protection for no array prototype
          this.currentCustomer.credit_margin = [];
          // Use the default value for pre-filling the calendar then
          this.credit_date = this.currentCustomer.credit_date;
          this.originalCreditDate = this.credit_date;
        }

        if (this.currentCustomer.id && this.currentCustomer.id != '0') {
          this._customerService.getOneCustomerBranches(this.currentCustomer.id).subscribe(
            (b: { id: string, branches: Branch[] }) => {
              if (Array.isArray(b.branches)) {
                this.currentCustomer.branches = b.branches;
              } else {
                this.currentCustomer.branches = [];
              }

              this.filterSalesmen();
            }
          );
        }

        this._loadingService.resolve('loading');
      });

    this.getCities();
  }

  filterSalesmen() {
    this.valid_salesmen = [];
    this.currentCustomer.branches.forEach(
      branch => {
        this._customerService.getUsersPerBranch(branch.id + '').subscribe(
          response => {
            if (Array.isArray(response)) {
              this.valid_salesmen = this.valid_salesmen.concat(response.map(i => i.first_name + ' ' + i.last_name));
            }

            this.valid_salesmen = Array.from(new Set(this.valid_salesmen));
          }
        );
      }
    );
  }

  checkBranch(branchItem: Branch): boolean {
    return (this.currentCustomer && this.currentCustomer.branches)
      ? this.currentCustomer.branches.filter((branch: Branch) => branch.id == branchItem.id).length > 0
      : false;
  }

  selectBranch(event: any, branchItem: any): any {
    this.currentCustomer.branches = this.currentCustomer.branches || [];
    return event.checked
      ? this.currentCustomer.branches.push(branchItem)
      : this.currentCustomer.branches = this.currentCustomer.branches.filter((branch: Branch) => branchItem.id != branch.id);
  }

  getCities() {
    this._locationService.getCity()
      .subscribe((cities: any[]) => {
        this.allCity = cities.map(city => {
          city.id = Number(city.id);
          return city;
        });
      });
  }

  fillShippingAddress(addr: string) {
    if (this.currentCustomer.shipping_address == null) {
      this.currentCustomer.shipping_address = addr;
    }
  }

  fillShippingCity(city_id: number) {
    if (this.currentCustomer.shipping_city_id == null) {
      this.currentCustomer.shipping_city_id = city_id;
    }
  }

  clearShipping($event) {
    if ($event) {
      delete this.currentCustomer.shipping_address;
      delete this.currentCustomer.shipping_city_id;
      delete this.currentCustomer.shipping_country_id;
    }
  }

  prettify(arr: { margin: number, date: Date }[]) {
    let output: string = '';

    arr.forEach(
      function (i: { margin: number, date: Date }) {
        output += 'Margin: ' + i.margin + ' - Date: ' + i.date + '\n';
      }
    );
    return output;
  }

  goBack(): void {
    this.location.back();
  }

  changed(): boolean {
    for (let prop in this.currentCustomer) {
      if (this.currentCustomer[prop] != this.originalCustomer[prop]) {
        return true;
      }
    }

    if (this.originalCreditMargin != this.credit_margin) {
      return true;
    }

    if (this.originalCreditDate != this.credit_date) {
      return true;
    }

    return false;
  }

  prependCreditMargin() {
    if (this.credit_margin != null && (this.currentCustomer.credit_margin.length == 0 || this.currentCustomer.credit_margin[0].margin != this.credit_margin)) {
      if (this.credit_date != null) {
        this.currentCustomer.credit_margin.unshift({
          margin: this.credit_margin,
          date: this.credit_date
        });
      } else {
        this.currentCustomer.credit_margin.unshift({
          margin: this.credit_margin,
          date: new Date().toISOString().substr(0, 10)
        });
      }
    }
  }

  createCustomer(): void {
    this._loadingService.register('loading');

    if (!this.currentCustomer.branches || !Array.isArray(this.currentCustomer.branches) || this.currentCustomer.branches.length == 0) {
      this._dialogService.openAlert({
        message: 'At least one branch is required to be checked',
        title: 'Error',
      });

      return;
    }

    this.prependCreditMargin();
    this._customerService.createCustomer(this.currentCustomer).subscribe(
      response => {
        if (response['status'] == 'SUCCESS') {
          this._customerService.setOneCustomerBranches(response['id'], this.currentCustomer.branches).subscribe(
            response => {

            },
            error => {

            }
          );

          this.currentCustomer.id = response['id'];

          // Reload up the reference data
          this.originalCustomer = Object.assign({}, this.currentCustomer);

          this.isEditMode = true;
          this._loadingService.resolve('loading');
          this._dialogService.openAlert({
            message: 'Customer ' + this.currentCustomer.name + ' created successfully!',
            title: 'Success!',
          }).afterClosed().subscribe((accept: boolean) => {
            this.router.navigate(['/accounting', 'customers']);
          });
        } else {
          this._loadingService.resolve('loading');

          this._dialogService.openAlert({
            message: 'Could not create customer ' + this.currentCustomer.name + ': ' + response.error.sqlMessage,
            title: 'Failed!',
          });
        }
      },
      error => {
        this._loadingService.resolve('loading');

        console.log(error.json())

        this._dialogService.openAlert({
          message: 'Error creating customer ' + this.currentCustomer.name + ': ' + error.json().error.sqlMessage,
          title: 'Error!',
        });
      },
      () => { }
    );
  }

  saveCustomer(): void {
    if (!this.currentCustomer.branches || !Array.isArray(this.currentCustomer.branches) || this.currentCustomer.branches.length == 0) {
      this._dialogService.openAlert({
        message: 'At least one branch is required to be checked',
        title: 'Error',
      });

      return;
    }

    if (!this._useShipping && (this.currentCustomer.shipping_address == null || this.currentCustomer.shipping_address == '' || this.currentCustomer.shipping_city_id == null || this.currentCustomer.shipping_city_id == 0)) {
      this._dialogService.openAlert({
        message: 'You selected to have a different Shipping address than the customer\'s official address. Please enter Shipping address and city or check the box for "Use same address for shipping"',
        title: 'Invalid data!',
      })
      return;
    }

    this._loadingService.register('loading');

    this.prependCreditMargin();
    this._customerService.updateCustomer(this.currentCustomer.id, this.currentCustomer).subscribe(
      response => {
        if (response['status'] == 'SUCCESS') {
          this._customerService.setOneCustomerBranches(this.currentCustomer.id, this.currentCustomer.branches).subscribe(
            response => {

            },
            error => {

            }
          );

          this._loadingService.resolve('loading');

          // Reload up the reference data
          this.originalCustomer = Object.assign({}, this.currentCustomer);

          this._dialogService.openAlert({
            message: 'Customer ' + this.currentCustomer.name + ' saved successfully!',
            title: 'Success!',
          }).afterClosed().subscribe((accept: boolean) => {
            this.router.navigate(['/accounting', 'customers']);
          });
        } else {
          this._loadingService.resolve('loading');

          this._dialogService.openAlert({
            message: 'Could not save customer ' + this.currentCustomer.name + '.',
            title: 'Failed!',
          });
        }
      },
      error => {
        this._loadingService.resolve('loading');

        this._dialogService.openAlert({
          message: 'Error updating customer ' + this.currentCustomer.name + ': ' + error,
          title: 'Error!',
        });
      },
      () => { }
    );
  }

  mode(id: string): Observable<Customer> {
    if (id) {
      this.title = 'Edit Customer';
      this.isEditMode = true;
      return this._customerService.getOneCustomer(id);
    }

    this.title = 'Create Customer';
    this.isEditMode = false;
    return Observable.of(new Customer());
  }

  openCreditDialog() {
    let dialogRef = this._dialog.open(CreditDialog);

    dialogRef.componentInstance.credits = this.currentCustomer.credit_margin;
  }

}



@Component({
  selector: 'credit-dialog',
  template: `
    <div flex layout="column" layout-margin layout-wrap>
      <div *ngFor="let c of credits">
        <span> Margin: {{c.margin}}  - Date: {{ c.date }}</span>
      </div>
    </div>
  `,
})
export class CreditDialog implements OnInit {
  credits: any[] = [];

  constructor(public dialogRef: MdDialogRef<CreditDialog>,
    private tdDialog: TdDialogService) { }

  ngOnInit() {

  }
}


// WEBPACK FOOTER //
// C:/Users/orion/Projects/simplicityEngine/valmust/valmustfe/src/app/agatextscreens/accounting/customer/customer/customer.component.ts